<template>
    <div>
        <h1 class="text-2xl font-thin">Welcome back!</h1>
        <p class="text-red-dark text-sm my-6" v-if="form.errors.message" v-html="form.errors.message"></p>
        <form
            class="mt-6"
            role="form"
            @submit.prevent="login"
        >
            <div class="mb-6">
                <label class="block text-sm mb-2 text-grey-darkest" for="email">Email Address</label>
                <input
                    class="appearance-none border text-grey-darker leading-tight focus:outline-none focus:shadow-outline h-10 px-4 w-full"
                    v-bind:class="{'border-red': form.errors.email}"
                    id="email"
                    type="email"
                    name="email"
                    v-model="form.email"
                    autofocus
                />
                <p class="text-red-dark text-sm mt-1" v-if="form.errors.email" v-html="form.errors.email"></p>
            </div>

            <div class="mb-6">
                <label class="block text-sm mb-2 text-grey-darkest" for="password">Password</label>
                <input
                    class="appearance-none border text-grey-darker leading-tight focus:outline-none focus:shadow-outline h-10 px-4 w-full"
                    v-bind:class="{'border-red': form.errors.password}"
                    id="password"
                    type="password"
                    name="password"
                    v-model="form.password"
                />

                <p class="text-red-dark text-sm mt-1" v-if="form.errors.password" v-html="form.errors.password"></p>
            </div>

            <button class="w-full bg-purple  hover:bg-purple-dark px-4 py-3 text-white rounded cursor-pointer dim" type="submit">
                Login
            </button>

        </form>
    </div>
</template>

<script>
import errors from '@/mixins/errors'

export default {
    name: 'login',
    mixins: [ errors ],
    data: () => ({
       form: {
           email: '',
           password: '',
           remember: false,
           errors: {}
       },
    }),

    methods: {
        login() {
            this.$auth.login({
                data: this.form, // Axios
                rememberMe: this.form.remember,
            }).catch(error => {
                this.form.errors = this.setErrors(error.response.data)
            });
        }
    }
}
</script>
